package ai.flowstorm.studio.ui.data

import ai.flowstorm.common.ui.Form
import ai.flowstorm.studio.model.ProfileRecord
import ai.flowstorm.studio.ui.form.EntityId
import ai.flowstorm.studio.ui.form.SessionRef
import ai.flowstorm.studio.ui.form.UserRef
import io.kvision.form.text.Text
import io.kvision.i18n.tr

class ProfilerRecordForm() : Form<ProfileRecord>(ProfileRecord.serializer()) {

    init {
        add(ProfileRecord::_id, EntityId(label = tr("ID")))
        add(ProfileRecord::personaName, Text(label = tr("Persona")))
        add(ProfileRecord::content, Text(label = tr("Content")))
        add(ProfileRecord::language, Text(label = tr("Language")))
        add(ProfileRecord::reliabilityAsText, Text(label = tr("Reliability (%)")))
        add(ProfileRecord::embeddingModel, Text(label = tr("Embedding Model")))
        add(ProfileRecord::timestampAsText, Text(label = tr("Timestamp")))
        add(ProfileRecord::session_id, SessionRef())
        add(ProfileRecord::user_id, Text(label = tr("User ID")))
        add(ProfileRecord::turn_id, Text(label = tr("Turn ID")))
        add(ProfileRecord::categoriesAsText, Text(label = tr("Categories")))
        add(ProfileRecord::tagsAsText, Text(label = tr("Tags")))
    }

    fun load(entity: ProfileRecord): ProfilerRecordForm {
        disableAll()
        setData(entity)
        return this
    }

}